<template>
  <vue-js-modal
    v-if="splitNode"
    :key="reload"
    id="agSplitNodeModal"
    class="agModal"
    name="agSplitNodeModal"
    draggable=".card-header"
    width="75%"
    height="85%"
    :shiftX=".5"
    :shiftY=".25"
    :resizable="true"
    :clickToClose="false">
    <b-card>
      <template #header>
          <h4 v-if="disableUI || isLoading" class="agModal-title">View Split Node {{splitNode.shortname}}</h4>
          <h4 v-else class="agModal-title">Edit Split Node {{splitNode.shortname}}</h4>
      </template>

      <div class="agInputGroup agInputGroupCentered">
        <label>Source:</label>
        <b-input type="text" v-model="srcStr" autocomplete="false" disabled></b-input>
      </div>
      <b-input-group size="md" prepend="Name">
        <b-input type="text" v-model="splitNode.name" autocomplete="false" :disabled="disableUI || isLoading"></b-input>
      </b-input-group>
      <b-input-group size="md" prepend="Description">
        <b-input type="text" v-model="splitNode.description" autocomplete="false" :disabled="disableUI || isLoading"></b-input>
      </b-input-group>
      <hr />
        <input
          type="checkbox"
          v-model="splitNode.hasBreakpoint"
          :disabled="disableUI || isLoading"/>
        <label>Has Breakpoint</label>

      <hr/>
      <div 
        v-for="(path, index) in splitNode.paths" 
        :key="index" 
        class="agSplitNodeModal-path">
        <div class="agInputGroup agInputGroupCentered">
          <label>Path {{index + 1}} Label:</label>
          <b-input 
            v-model="path.label"
            :key="'paths-' + index + '-' + reloadPaths"
            class="agSplitNodeModal-pathLabelText agInput agMediumInput"
            maxlength=25>
          </b-input>       
          <button
            class="agSplitNodeModal-deletePathButton agDeleteButton agTextButton"
            :disabled="disableUI || isLoading"
            @click="deletePathButton_click(index)">
            Delete
          </button>
        </div>
      </div>
      <button
        id="splitNodeNodeModal-addPathButton"
        class="agTextButton"
        :disabled="disableUI || isLoading"
        @click="addPathButton_click">
        Add Path
      </button>    

      <template #footer>
        <b-spinner v-if="isLoading" class="agModal-loadingSpinner"></b-spinner>
        <div v-else-if="modalMessage">
          <label class="agModal-message" :class="modalMessageClass">{{modalMessage}}</label>
        </div>

        <b-button class="agModal-buttonLeft" @click="cancelButton_click">Cancel</b-button>
        <b-button
          class="agModal-buttonRight"
          variant="primary"
          :disabled="disableUI || isLoading"
          @click="saveButton_click">
          Save
        </b-button>
        <b-button
          class="agModal-buttonRight"
          variant="danger"
          :disabled="disableUI || isLoading"
          @click="deleteButton_click">
          Delete
        </b-button>
      </template>
    </b-card>

    <!-- delete modal -->
    <b-modal
      class="agModal"
      ref="deleteModal"
      centered
      no-close-on-esc
      no-close-on-backdrop
      @keyup.enter.native="deleteButton_click">
      <template slot="modal-header">
        <h4 class="agModal-title danger">Delete Split</h4>
      </template>
      Are you sure you want to delete split
      <i>{{name}}</i>?
      <template slot="modal-footer" slot-scope="{cancel}">
        <b-button class="agModal-buttonLeft" @click="cancel">Cancel</b-button>
        <b-button
        class="agModal-buttonRight"
        variant="danger"
        @click="confirmDeleteButton_click"
        >Delete</b-button>
      </template>
    </b-modal>

  </vue-js-modal>
</template>


<script>
// components

// modules
import Vue from "vue";
import Util from "src/util/util";

export default {
  name: "ag-split-modal",
  props: {
    node: Object,
    workflow: Object,
    disableUI: Boolean
  },
  components: {
  },
  data() {
    return {
      splitNode: null,
      reload:0,
      reloadPaths: 0,
      isLoading: false,
      modalMessage: "",
      modalMessageClass: ""
    };
  },
  computed: {

    name() {
      if (this.splitNode.name)
        return this.splitNode.name;
      
      return this.splitNode.shortname;
    },

    srcStr() {
      if (!this.splitNode.src || this.splitNode.src.length == 0) 
        return "";

      var srcStr = "";
      for (var i = 0; i < this.splitNode.src.length; i++) {
        var src = this.splitNode.src[i];
        srcStr += src.shortname + ", ";
      }
      srcStr = srcStr.substring(0, srcStr.length - 2); // remove the last ,
      return srcStr;
    }
  },

  watch: {

  },

  mounted() {},

  methods: {

    // UI Events
    

    addPathButton_click(){
        var path = {
          label: null,
          dest: null
        }
        this.splitNode.paths.push(path);
        this.reloadPaths++;
    },

    deletePathButton_click(index) {
      this.splitNode.paths = Util.removeFromArrayByIndex(
        this.splitNode.paths,
        index
      );
      this.reloadPaths++;
    },
    
    async saveButton_click() {
      this.modalMessage = "";
      var node = {
        object: this.splitNode,
        type: "splitNode"
      };
      this.isLoading = true;
      var result = await this.$store.dispatch("nodeStore/updateNode", {
        node: node
      });
      this.isLoading = false;
      if (result.data.success) {
        var updated = {
          type: "splitNode",
          object: result.data.node
        };
        this.hide();
        this.$emit("updatedNode", updated);
      } else {
        this.modalMessage = result.data.error;
        this.modalMessageClass = "agModal-errorMessage";
      }
    },

    cancelButton_click() {  
      this.hide();
    },

    deleteButton_click() {
      this.$refs.deleteModal.show();
    },

    async confirmDeleteButton_click() {
      this.$refs.deleteModal.hide();
      var node = {
        object: this.splitNode,
        type: "splitNode"
      };
      this.isLoading = true;
      var result = await this.$store.dispatch("nodeStore/deleteNode", {
        node: node
      });
      this.$emit("deletedNode", node);
      this.isLoading = false;
      this.hide();
    },

    // emitted events

    // other
    async show() {
      await this.setSplitNode();
      await Vue.nextTick();
      await this.reset();
      this.$modal.show("agSplitNodeModal");
    },

    hide() {
      this.$modal.hide("agSplitNodeModal");
    },

    async reset() {
      this.modalMessage = "";
      this.modalMessageClass = "";
      this.errorField = "";
    },

    async setSplitNode() {
      if(this.node && this.node.type == "splitNode") 
        this.splitNode = this.workflow.splitNodes.find((object) => object._id == this.node.object._id);
      else
        this.splitNode = null;
    },


    getNameForDest(dest) {
      if (dest) return dest.shortname;
      return "";
    },

  }
};
</script>


<style scoped lang="css">

.agSplitNodeModal-deletePathButton {
  position: relative;
  left: 25px;
  font-size: 16px;
}

.agSplitNodeModal-addPathButton {
  display: block;
  margin: 25px auto;
  font-size: 18px;
}

</style>


// WEBPACK FOOTER //
// src/components/nodes/SplitNodeModal.vue